import { getEditorVersion, getWebBuildTime } from '@/utils/version.utils';
import { ElectronApi } from '@/services/electron.api';
const isProduction = import.meta.env.PROD;

const getBaseTrackInfo = (() => {
  let base: Record<string, string>;
  return async () => {
    if (base) return base;
    const editor_version = await getEditorVersion();
    const version_type = ElectronApi.versionType();
    const build_time = getWebBuildTime() as string;
    base = { editor_version, version_type, build_time };
    return base;
  };
})();

export function initOnetrack() {
  if (!isProduction) return;
  getBaseTrackInfo();

  // 接入文档：https://xiaomi.f.mioffice.cn/wiki/wikk4YEz9SMMCOFIGvu00MSxBwd#6Otey3
  const scriptContent = document.createElement('script');
  scriptContent.textContent = `
    window.onetrack = window.onetrack || function() {
      (onetrack.q = onetrack.q || []).push(arguments);
    };
    onetrack('init', '31000401806');
  `;

  const scriptSrc = document.createElement('script');
  scriptSrc.async = true;
  scriptSrc.src =
    'https://ssl-cdn.static.browser.mi-img.com/mistat-data/onetrack/onetrack.js';

  document.head.appendChild(scriptContent);
  document.head.appendChild(scriptSrc);

  // 开启调试
  localStorage.setItem('_onetrack_debug', '1');
}

export function clickTrack(eventName: string, params: Record<string, any>) {
  oneTrackInfo('click', { ...params, click_event_name: eventName });
}

export function oneTrackInfo(eventName: string, params: Record<string, any>) {
  if (!isProduction || !window.onetrack) {
    return;
  }
  getBaseTrackInfo()
    .then((base) => {
      if (window === undefined || window.onetrack === undefined) return;
      window.onetrack('track', eventName, {
        ...params,
        ...base
      });
    })
    .catch((e) => {
      console.log(e);
    });
}
